import { render, staticRenderFns } from "./LearnSituation.vue?vue&type=template&id=aea73d32&scoped=true&"
import script from "./LearnSituation.vue?vue&type=script&lang=js&"
export * from "./LearnSituation.vue?vue&type=script&lang=js&"
import style0 from "./LearnSituation.vue?vue&type=style&index=0&id=aea73d32&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aea73d32",
  null
  
)

export default component.exports